/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Domain { 
    domainId?: string;
    domainName?: string;
    domainExpirationDate?: string;
    domainStatus?: Domain.DomainStatusEnum;
    autoRenewEnabled?: boolean;
    redirectUrl?: string;
    efan?: string;
}
export namespace Domain {
    export const DomainStatusEnum = {
        New: 'NEW',
        Reserved: 'RESERVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        AwaitingExpiration: 'AWAITING_EXPIRATION'
    } as const;
    export type DomainStatusEnum = typeof DomainStatusEnum[keyof typeof DomainStatusEnum];
}


